import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from '../utils/api';

const AuthContext = createContext();

const applyAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    try { localStorage.setItem('token', token); } catch { }
  } else {
    delete axios.defaults.headers.common['Authorization'];
    try { localStorage.removeItem('token'); } catch { }
  }
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => {
    try { return localStorage.getItem('token'); } catch { return null; }
  });
  const [user, setUser] = useState(() => {
    try { const raw = localStorage.getItem('user'); return raw ? JSON.parse(raw) : null; } catch { return null; }
  });

  useEffect(() => {
    applyAuthToken(token);
  }, [token]);

  useEffect(() => {
    if (user) localStorage.setItem('user', JSON.stringify(user));
    else localStorage.removeItem('user');
  }, [user]);

  const login = async ({ email, password }) => {
    const res = await axios.post('/api/users/login', { email, password });
    if (res && res.data) {
      applyAuthToken(res.data.token);
      setToken(res.data.token);
      setUser(res.data.user);
    }
    return res;
  };

  const register = async ({ name, email, password }) => {
    const res = await axios.post('/api/users/register', { name, email, password });
    if (res && res.data) {
      applyAuthToken(res.data.token);
      setToken(res.data.token);
      setUser(res.data.user);
    }
    return res;
  };

  const logout = () => { applyAuthToken(null); setToken(null); setUser(null); };

  return (
    <AuthContext.Provider value={{ token, user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
